//
//
//
//
//
//
//
//
//
//
//
//
//

import parkinglotCouponList from '../index.vue';
export default {
  name: 'ParkinglotCouponFrom',
  components: {
    parkinglotCouponList: parkinglotCouponList
  },
  data: function data() {
    return {
      visible: false,
      callback: function callback() {},
      useType: 1
    };
  },
  watch: {
    // show() {
    //   this.visible = this.show
    // }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.visible = false;
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    getParkinglotCouponId: function getParkinglotCouponId(couponObj) {
      this.callback(couponObj);
      this.visible = false;
    }
  }
};